<template>
  <div>
    <Header></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="padding-bottom: 30px">
      <div class="applyBody">
        <!--申请表正文-->
        <div class="applyDiv">
          <!--标题-->
          <div class="applyHead">
            <p class="applyHeadP">企业会员申请</p>
          </div>
          <!--基础资料-->
          <div class="applyBox">
            <p class="applyTitle">基本资料</p>
            <div class="applySpanBox">
              <p>企业全称：</p>
              <p>单位性质：</p>
              <p>经济类型：</p>
              <p>所属类别：</p>
              <p>法人代表：</p>
              <p>注册地址：</p>
              <p>成立时间：</p>
              <p>注册资金：</p>
            </div>
            <div class="applyFormBox form-group">
              <input type="text" class="col-11 form-control applyFormText" v-model="company_name">
              <select class="applyFormText col-11 form-control" v-model="property">
                <option v-for="(item, key) in propertys" :key="key" :value="key">{{item}}</option>
              </select>
              <select class="applyFormText col-11 form-control" v-model="economic">
                <option v-for="(item, key) in economics" :key="key" :value="key">{{item}}</option>
              </select>
              <select class="applyFormText col-11 form-control" v-model="cate1">
                <option v-for="(item, key) in cate1s" :key="key" :value="key">{{item}}</option>
              </select>
              <input type="text" class="col-11 form-control applyFormText" v-model="representative">
              <input type="text" class="col-11 form-control applyFormText" v-model="regaddr">
              <el-date-picker style="width: 293px;" type="month" class="applyFormText" format="yyyy-MM" value-format="yyyy-MM" v-model="born"></el-date-picker>
              <input type="text" class="col-11 form-control applyFormText" v-model="registered">
            </div>
          </div>
          <!--联系方式-->
          <div class="applyBox">
            <p class="applyTitle">联系方式</p>
            <div class="applySpanBox">
              <p>通讯地址：</p>
              <p class="pb">联系人1(必填)</p>
              <p> 电话：</p>
              <p> 手机：</p>
              <p> 邮箱：</p>
              <p class="pb">联系人2(非必填)</p>
              <p> 电话：</p>
              <p> 手机：</p>
              <p> 邮箱：</p>
            </div>
            <div class="applyFormBox form-group">
              <input type="text" class="applyFormText col-11 form-control" v-model="contract_addr">
              <input type="text" class="applyFormText col-11 form-control" v-model="contract1_tel" style="margin-top: 80px">
              <input type="text" class="applyFormText col-11 form-control" v-model="contract1_mobile">
              <input type="text" class="applyFormText col-11 form-control" v-model="contract1_mail">
              <input type="text" class="applyFormText col-11 form-control" v-model="contract2_tel" style="margin-top: 80px">
              <input type="text" class="applyFormText col-11 form-control" v-model="contract2_mobile">
              <input type="text" class="applyFormText col-11 form-control" v-model="contract2_mail">
            </div>
          </div>
          <!--详细资料-->
          <div class="applyBox">
            <p class="applyTitle">公司情况</p>
            <div class="applySpanBox">
              <p>工程师人数：</p>
              <p>技术员人数：</p>
              <p>设备情况：</p>
            </div>
            <div class="applyFormBox form-group">
              <input type="text" class="applyFormText col-11 form-control" v-model="engineer">
              <input type="text" class="applyFormText col-11 form-control" v-model="technician">
              <textarea type="text" class="applyFormText col-11 form-control" id="university" v-model="state" rows="4"></textarea>
            </div>
          </div>
          <!--资料提交-->
          <div class="applyBox">
            <p class="applyTitle">资料提交</p>
            <div class="applySpanBox">
              <p style="margin-top: 10px">会员类型：</p>
              <p style="margin-top: 15px;margin-bottom: 171px">营业执照：</p>
              <p style="margin-top: 15px;margin-bottom: 171px">资质证书：</p>
              <p style="margin-top: 15px;margin-bottom: 171px">申请报告：</p>
            </div>
            <div class="applyFormBox form-group" style="margin-top: 10px;margin-left: 10px">
              <select class="applyFormText col-11 form-control" v-model="membership">
                <option v-for="(item, key) in memberships" :key="key" :value="key">{{item}}</option>
              </select>
              <!--营业执照-->
              <form>
                <div class="fileBtnBox">
                  <img :src="uploadImgs.License" v-show="uploadImgs.License !== ''">
                  <img src="../assets/img/imguploadbtn.png" v-show="uploadImgs.License === ''">
                  <input type="file" @change="getFile($event)" name="upload" index="License" class="imgUpload">
                </div>
                <input type="hidden" name="from" value="upload">
                <input type="hidden" name="dir" value="images">
              </form>
              <!--资质证书-->
              <form>
                <div class="fileBtnBox">
                  <img :src="uploadImgs.Certificate" v-show="uploadImgs.Certificate !== ''">
                  <img src="../assets/img/imguploadbtn.png" v-show="uploadImgs.Certificate === ''">
                  <input type="file" @change="getFile($event)" name="upload" index="Certificate" class="imgUpload">
                </div>
                <input type="hidden" name="from" value="upload">
                <input type="hidden" name="dir" value="images">
              </form>
              <!--申请报告-->
              <form>
                <div class="fileBtnBox">
                  <img :src="uploadImgs.Report" v-show="uploadImgs.Report !== ''">
                  <img src="../assets/img/imguploadbtn.png" v-show="uploadImgs.Report === ''">
                  <input type="file" @change="getFile($event)" name="upload" index="Report" class="imgUpload">
                </div>
                <input type="hidden" name="from" value="upload">
                <input type="hidden" name="dir" value="images">
              </form>
              <a style="font-size: 13px;" class="explain" @click="enterpriseApplication">下载企业入会申请书模版，打印并盖公章，然后拍照或扫描上传</a>
            </div>
          </div>
          <!--提交按钮-->
          <div class="applyBox">
            <div class="applyFormBox form-group">
              <input type="button" class="applyFormBtn btn" value="注册" @click="companyRegister">
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemMember from '@/components/item/itemMember.vue'
import choiceApply from '@/components/apply/choiceApply.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'
import ChoiceApply from './apply/choiceApply'

export default {
  name: 'enterpriseApplyAgain',
  data () {
    return {
      // 所在页面的名称
      topName: 'apply',
      // 顶部导航栏
      ifblueme: {
        color: '#0051bd'
      },
      // 副导航栏
      ifSelection: 0,
      // 面包屑导航栏
      secondhref: '/enterpriseApplyAgain',
      secondtest: '重新审核',
      // 副导航栏信息
      cate: [],
      // 会员信息
      member: [],
      // 用于正则判断的样式参数
      ifErrPrompt: false,
      // 图片上传后返回的路径
      uploadImgs: {
        License: '', // 营业执照
        Certificate: '', // 资质证书
        Report: '' // 申请报告
      },
      // 下拉选项
      propertys: [],
      economics: [],
      cate1s: [],
      memberships: [],
      // 企业注册表单数据
      group: '1', // 会员申请类型，个人是0，企业是1
      company_name: '',
      born: '',
      registered: '',
      representative: '',
      property: '',
      economic: '',
      cate1: '',
      regaddr: '',
      contract1_tel: '',
      contract1_mobile: '',
      contract1_mail: '',
      contract2_tel: '',
      contract2_mobile: '',
      contract2_mail: '',
      contract_addr: '',
      engineer: '',
      technician: '',
      state: '',
      /* 图片文件的id */
      imgFiles: {
        License: '',
        Certificate: '',
        Report: ''
      },
      membership: ''
    }
  },
  components: {
    ChoiceApply,
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemMember: itemMember,
    choiceApply: choiceApply
  },
  methods: {
    // 图片提交事件
    getFile (event) {
      // 取消默认动作
      event.preventDefault()
      // 拿到控件标识符
      let thisIndex = event.target.getAttribute('index')
      // 获得文件值
      this.file = event.target.files[0]
      // 模拟form数据
      let formData = new FormData()
      formData.append('from', 'upload')
      formData.append('dir', 'images')
      formData.append('upload', this.file)
      // 定义请求头
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      // 调用接口
      this.$http.post('http://api.gdics.cn/api/imgupload', formData, config)
      // 请求成功
        .then(function (res) {
          if (res.body.code === 200) {
            this.uploadImgs[thisIndex] = res.body.data.path
            this.imgFiles[thisIndex] = res.body.data.id
          } else {
            this.$message.error(res.body.msg + '，请不要超过2m')
          }
        })
        // 请求失败
        .catch(function (err) {
          this.$message.error('附件过大，请不要超过2m')
          console.log(err)
        })
    },

    // 注册提交事件
    companyRegister: function () {
      console.log(this.$store.state.Token)
      // 配置请求头，带上token
      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.Token
        }
      }
      // 调用post请求接口
      this.$http.post('http://api.gdics.cn/api/vcm', {
        company_name: this.company_name,
        born: this.born,
        registered: this.registered,
        representative: this.representative,
        economic: this.economic,
        property: this.property,
        regaddr: this.regaddr,
        cate: this.cate1,
        contract1_tel: this.contract1_tel,
        contract1_mobile: this.contract1_mobile,
        contract1_mail: this.contract1_mail,
        contract2_tel: this.contract2_tel,
        contract2_mobile: this.contract2_mobile,
        contract2_mail: this.contract2_mail,
        contract_addr: this.contract_addr,
        engineer: this.engineer,
        technician: this.technician,
        state: this.state,
        license: this.imgFiles.License, // 营业执照
        certificate: this.imgFiles.Certificate, // 资质证书
        report: this.imgFiles.Report, // 申请报告
        membership: this.membership
      }, config).then(res => {
        console.log(res)
        if (res.status !== 200) { // 服务器失败
          this.$message.error('服务器未响应')
        } else if (res.body.code !== 200) {
          this.$message.error(res.body.msg)
        } else {
          this.$message.success('注册成功')
          this.$router.push('/')
        }
      })
    },

    // 副导航栏渲染
    viceNavigation (event) {
      this.ifSelection = +event.target.id
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection).then(res => {
        this.member = res.member
        this.cate = res.cate
      })
    },

    // 下载企业入会申请书模板
    enterpriseApplication: function () {
      HttpServer.get('http://api.gdics.cn/api/download_file').then(res => {
        window.location.href = res.msg[1].path
      })
    }
  },
  mounted () {
    // get请求，渲染下拉选项
    HttpServer.get('http://api.gdics.cn/api/signinfo').then(res => {
      this.propertys = res.msg.property
      this.economics = res.msg.economic
      this.cate1s = res.msg.cate
      this.memberships = res.msg.company
    })

    // get请求，渲染表单内容
    // 配置请求头
    let config = {
      headers: {
        'Authorization': 'Bearer ' + this.$store.state.Token
      }
    }
    HttpServer.get('http://api.gdics.cn/api/userinfo', config)
      .then(res => { // 请求成功,把传过来的数据一个个填进去
        this.company_name = res.data.company_name
        this.born = res.data.born
        this.registered = res.data.registered
        this.representative = res.data.representative
        this.economic = res.data.economic
        this.property = res.data.property
        this.regaddr = res.data.regaddr
        this.cate1 = res.data.cate
        this.contract1_tel = res.data.contract1_tel
        this.contract1_mobile = res.data.contract1_mobile
        this.contract1_mail = res.data.contract1_mail
        this.contract2_tel = res.data.contract2_tel
        this.contract2_mobile = res.data.contract2_mobile
        this.contract2_mail = res.data.contract2_mail
        this.contract_addr = res.data.contract_addr
        this.engineer = res.data.engineer
        this.technician = res.data.technician
        this.state = res.data.state
        this.imgFiles.License = res.data.license // 营业执照
        this.imgFiles.Certificate = res.data.certificate // 资质证书
        this.imgFiles.Report = res.data.report // 申请报告
        this.membership = res.data.membership
        // get请求，得到个人信息的数据后，要拿license、certificate、report这3个值去再请求一次接口，拿到相关的图片
        HttpServer.get('http://api.gdics.cn/api/media?media_id=' + this.imgFiles.License + ',' + this.imgFiles.Certificate + ',' + this.imgFiles.Report).then(res => {
          this.uploadImgs.License = res.data[0]
          this.uploadImgs.Certificate = res.data[1]
          this.uploadImgs.Report = res.data[2]
        })
      }).catch(err => {
        console.log(err)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .applyBody{
    width: 1000px;
    margin-left: auto;
    margin-right: auto;
    text-align: right;
  }
  .applyTips{
    font-size: 12px;
    margin-bottom: 15px;
  }
  .applyTips a{
    color: #999999;
  }
  .applyDiv{
    width: 100%;
    border-radius: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: #ffffff;
  }
  .applyHead{
    width: 100%;
    height: 50px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 30px;
  }
  .applyHeadP{
    margin-top: auto;
    margin-bottom: auto;
    line-height: 50px;
    font-size: 24px;
    background-color: #0064e6;
    font-family: '微软雅黑';
  }
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
  .applyBox{
    position: relative;
    width: 80%;
    background-color: #ffffff;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    overflow: hidden;
    border-bottom: 1px solid #e3e3e3;
  }
  .applyTitle{
    position: absolute;
    top: 8px;
    left: 20px;
    color:#007bff;
    font-weight: 600;
    font-family: '微软雅黑';
  }
  .applySpanBox{
    width: 40%;
    float: left;
    padding-top: 8px;
    padding-left: 200px;
  }
  .applyFormBox{
    width: 40%;
    float: right;
    margin-right: 150px;
  }
  .applySpanBox p{
    width: 100%;
    margin-bottom: 34px;
    float: right;
    color: #999999;
  }
  .applySpanBox .pb{
    width: 100%;
    margin-bottom: 34px;
    float: right;
    font-weight: 600;
    color: #999999;
  }
  .applyFormText{
    margin-bottom: 20px;
  }
  /* 提示文字的样式 */
  .applyFormText::-webkit-input-placeholder { /* WebKit browsers */
    color: #cdcdcd !important;
  }
  .applyFormText:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #cdcdcd !important;
  }
  .applyFormText::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #cdcdcd !important;
  }
  .applyFormText:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #cdcdcd !important;
  }
  .applyFormA{
    margin: 30px;
    line-height: 36px;
  }
  .applyFormLab{
    margin-left: 10px;
    font-size: 14px;
    color: #999999;
    font-family: '微软雅黑';
  }
  .applyFormBtn{
    width: 290px;
    color: #ffffff;
    background-color: #0064e6;
  }
  .applyFormRadio{
    margin-right: 10px;
    margin-left: 10px;
  }
  /* 图片上传控件样式 */
  .imgUpload{
    opacity: 0;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .fileBtnBox{
    margin-top: 30px;
    width: 293px;
    height: 180px;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    position: relative;
    cursor: pointer;
    overflow: hidden;
  }
  .fileBtnBox img{
    width: 100%;
  }
  /* 模板下载 */
  .explain{
     font-size: 11px;
     cursor: pointer;
     color: #007bff !important;
   }
  /* 用于正则判断的样式 */
  .ErrPrompt{
    border: 1px #f56e6e solid;
    margin-bottom: 12px;
  }
  .errP{
    font-size: 12px;
    color: #f56e6e;
    margin-bottom: 10px;
    line-height: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseApplyAgain.vue